var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6185 16.0038C12.5633 15.9618 12.5062 15.9184 12.4528 15.8755C12.1693 15.6482 11.8677 15.4388 11.576 15.2362C11.5155 15.1942 11.455 15.1521 11.3946 15.11C11.021 14.8486 10.6851 14.7215 10.3678 14.7215C9.94033 14.7215 9.56766 14.9568 9.26008 15.4207C9.15329 15.5819 8.64422 15.3954 8.4749 15.3189C7.26892 14.7741 6.40777 13.9389 5.91533 12.8364C5.67727 12.3036 5.62746 12.2609 6.04641 11.9774C6.28431 11.8166 6.72713 11.5172 6.69577 10.9438C6.66025 10.2926 5.21791 8.33343 4.6102 8.11091C4.3529 8.01666 4.08257 8.01578 3.80525 8.10871C3.10663 8.34265 2.6053 8.75349 2.35531 9.29673C2.11373 9.82165 2.12464 10.438 2.38686 11.0791C3.14491 12.9329 4.21068 14.5491 5.55469 15.8828C6.87024 17.1884 8.48716 18.2578 10.3605 19.0613C10.5293 19.1337 10.7065 19.1731 10.8358 19.2019C10.8799 19.2118 10.9179 19.2202 10.9456 19.2278C10.9609 19.2319 10.9766 19.2342 10.9924 19.2344H11.0072C11.8883 19.2344 12.9463 18.4324 13.2712 17.5181C13.5559 16.7175 13.0361 16.3218 12.6185 16.0038Z",
    stroke: "#413958",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1672 3.36365H10.0542C9.33344 3.36365 8.70001 3.79879 8.70001 4.51677V10.4564C8.71076 11.2042 9.30421 11.8145 10.0542 11.8489H13.4664C13.5789 11.8423 13.6893 11.8815 13.7722 11.9577L16.1569 14.5143C16.2389 14.6022 16.3859 14.5627 16.4128 14.4455L16.9393 12.1535C16.9822 11.9632 17.1591 11.8333 17.3543 11.8489H19.1672C19.888 11.8489 20.3686 11.1744 20.3686 10.4564V4.51677C20.3686 3.79879 19.888 3.36365 19.1672 3.36365Z",
    stroke: "#413958",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.656 6.33154L17.4125 6.33154",
    stroke: "#413958",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.656 8.85358L14.5259 8.85358",
    stroke: "#413958",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.be2a83faacbf0b915d4e7f613bbb22ad.svg";
export { ForwardRef as ReactComponent };